import React from 'react';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';
// Assets
import styles from './mailsort.module.scss';
// Interfaces
import { IItem } from '../../interfaces/general.interfaces';
import { SortAction } from '../../enums';
// Components
import { CustomLink, SpriteImage } from '..';

interface IMailSortState {
    selectedSortAction: IItem;
    showDropDownList: boolean;
}

interface IMailSortProps extends WrappedComponentProps {
    onSortActionSelected: (action: SortAction) => void;
}

class MailSort extends React.Component<IMailSortProps, IMailSortState> {
    private buttonRef = React.createRef<HTMLDivElement>();

    sortActionList: Array<IItem> = [
        { key: 'SORT_BY_DATE_NEWEST_TOP', value: SortAction.SORT_BY_DATE_NEWEST_TOP },
        { key: 'SORT_BY_DATE_NEWEST_BOTTOM', value: SortAction.SORT_BY_DATE_NEWEST_BOTTOM },
        { key: 'SORT_BY_SENDER_ATO_Z', value: SortAction.SORT_BY_SENDER_ATO_Z },
        { key: 'SORT_BY_TITLE_ATO_Z', value: SortAction.SORT_BY_TITLE_ATO_Z },
        // { key: "SORT_BY_NOTES", value: sortAction.SORT_BY_NOTES }  Maybe neede later on
    ];

    constructor(props: IMailSortProps) {
        super(props);
        this.state = {
            selectedSortAction: this.sortActionList[0],
            showDropDownList: false,
        };
    }

    componentDidMount() {
        window.addEventListener('mousedown', this.handleOutsideClick);
        window.addEventListener('touchstart', this.handleOutsideClick);
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.handleOutsideClick);
        window.removeEventListener('touchstart', this.handleOutsideClick);
    }

    handleOutsideClick = (event: MouseEvent | TouchEvent) => {
        const node = event.target as Element;

        if (this.state.showDropDownList && this.buttonRef.current && this.buttonRef.current.contains(node)) {
            return;
        }

        this.setState({ showDropDownList: false });
    };

    changeShowDropDownList = (event: React.MouseEvent) => {
        this.setState({ showDropDownList: !this.state.showDropDownList });
    };

    getDropDownButton = () => {
        return (
            <div
                ref={this.buttonRef}
                className={[styles.actionItem, 'd-flex align-items-center'].join(' ')}
                onClick={(event) => this.changeShowDropDownList(event)}
                title={this.props.intl.formatMessage({ id: this.state.selectedSortAction.key })}
            >
                <div className="d-flex align-items-center h-100">
                    <CustomLink
                        variant="dark"
                        className={[
                            'd-flex pr-0 pl-1 align-items-center styleless w-100 h-100',
                            styles.customLink,
                            styles.sortToggle,
                        ].join(' ')}
                        onClick={(event) => this.changeShowDropDownList(event)}
                    >
                        <FormattedMessage id="SORT_BY" />
                        <em className={[styles.chevron, 'd-flex pl-2'].join(' ')} tabIndex={-1} />
                    </CustomLink>
                    <div
                        className={[
                            'd-flex',
                            styles.sortDropDownList,
                            styles.dropDownContainer,
                            styles.alignRight,
                        ].join(' ')}
                    >
                        {this.state.showDropDownList ? this.getDropDownList() : null}
                    </div>
                </div>
            </div>
        );
    };

    getDropDownList = () => {
        const actions = this.sortActionList;
        const listElements: JSX.Element[] = [];

        actions.forEach((action, index) => {
            listElements.push(
                <li
                    className="d-flex align-items-center pr-4"
                    key={'item' + index}
                    onClick={() => this.handleSelectionAction(action)}
                >
                    <SpriteImage className={['d-flex mx-2', styles.whiteSelected].join(' ')} tabIndex={-1} />
                    <CustomLink
                        variant="dark"
                        className={[
                            'd-flex align-items-center pr-2',
                            styles.customLink,
                            action === this.state.selectedSortAction ? 'font-weight-bold' : 'font-weight-normal',
                        ].join(' ')}
                        key={'action' + index}
                    >
                        <FormattedMessage key={'fMsg' + index} id={action.key} />
                    </CustomLink>
                </li>
            );
        });

        return <ul>{listElements}</ul>;
    };

    handleSelectionAction = (action: IItem) => {
        this.setState({ selectedSortAction: action });
        if (this.props.onSortActionSelected) {
            this.props.onSortActionSelected(action.value as SortAction);
        }
    };

    public render() {
        return (
            <div
                className={[
                    'd-flex align-items-center justify-content-end mt-sm-2 mt-lg-0 align-self-end',
                    styles.mailboxTopSorting,
                ].join(' ')}
            >
                {this.getDropDownButton()}
            </div>
        );
    }
}

export default injectIntl(MailSort);
